var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.349 1.667H4.015A1.52 1.52 0 0 0 2.5 3.182v9.848c0 .417.34.758.758.758a.76.76 0 0 0 .757-.758V3.94a.76.76 0 0 1 .758-.758h7.576a.76.76 0 0 0 .757-.758.76.76 0 0 0-.758-.757m.447 3.477 3.659 3.659c.28.28.439.667.439 1.068v6.947a1.52 1.52 0 0 1-1.515 1.515H7.038a1.513 1.513 0 0 1-1.508-1.515l.008-10.606c0-.833.674-1.515 1.507-1.515h4.675c.401 0 .788.159 1.076.447M12.349 10h3.409L11.59 5.833v3.41c0 .416.34.757.758.757"
  })));
};
export default SvgCopy;